import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';

const options = [
  'None',
  'Atria',
  'Callisto',
  'Dione',
  'Ganymede',
  'Hangouts Call',
  'Luna',
  'Oberon',
  'Phobos',
  'Pyxis',
  'Sedna',
  'Titania',
  'Triton',
  'Umbriel',
];

export default function CoinUseConfirmationDialog(props) {
  const {onClose, value: valueProp, open, coin, hours, ...other} = props;
  const [value, setValue] = React.useState(valueProp);
  const radioGroupRef = React.useRef(null);

  React.useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }
  }, [valueProp, open]);

  const handleEntering = () => {
    if (radioGroupRef.current != null) {
      radioGroupRef.current.focus();
    }
  };

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    onClose(value);
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <Dialog
      sx={{'& .MuiDialog-paper': {width: '80%', maxHeight: 435}}}
      maxWidth="xs"
      TransitionProps={{onEntering: handleEntering}}
      open={open}
      {...other}
    >
      <DialogTitle>Confirm</DialogTitle>

      <DialogContent dividers>
        <Typography variant="body1" gutterBottom>
          "Title of the question goes here". body1. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos
          blanditiis tenetur unde suscipit
        </Typography>
        <br/>
        <p>Boost this poll for <b>{hours} hour</b> using <b>{coin}</b> coins?</p>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleOk}>Ok, Boost it!</Button>
      </DialogActions>
    </Dialog>
  );
}

CoinUseConfirmationDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
  coin: PropTypes.number.isRequired,
  hours: PropTypes.number.isRequired
};

// export default function CoinUseConfirmationDialog() {
//     const [open, setOpen] = React.useState(false);
//     const [value, setValue] = React.useState('Dione');
//
//     const handleClickListItem = () => {
//         setOpen(true);
//     };
//
//     const handleClose = (newValue) => {
//         setOpen(false);
//
//         if (newValue) {
//             setValue(newValue);
//         }
//     };
//
//     return (
//         <Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
//             <List component="div" role="group">
//                 <ListItemButton divider disabled>
//                     <ListItemText primary="Interruptions" />
//                 </ListItemButton>
//                 <ListItemButton
//                     divider
//                     aria-haspopup="true"
//                     aria-controls="ringtone-menu"
//                     aria-label="phone ringtone"
//                     onClick={handleClickListItem}
//                 >
//                     <ListItemText primary="Phone ringtone" secondary={value} />
//                 </ListItemButton>
//                 <ListItemButton divider disabled>
//                     <ListItemText primary="Default notification ringtone" secondary="Tethys" />
//                 </ListItemButton>
//                 <ConfirmationDialogRaw
//                     id="ringtone-menu"
//                     keepMounted
//                     open={open}
//                     onClose={handleClose}
//                     value={value}
//                 />
//             </List>
//         </Box>
//     );
// }
